const imagePath = '../assets/';
const configImages = {
  vid: require(`../assets/img/logo/video1.jpeg`),
  csv: require(`../assets/img/logo/csv.png`),
  xlsx: require(`../assets/img/logo/xlsx.png`),
  xls: require(`../assets/img/logo/xlsx.png`),
  ppt: require(`../assets/img/logo/ppt.jpg`),
  pdf: require(`../assets/img/logo/pdf.jpg`),
  json: require(`../assets/img/logo/json.jpg`),
  txt: require(`../assets/img/logo/txt.jpg`),
  docx: require(`../assets/img/logo/docx.jpg`),
  doc: require(`../assets/img/logo/docx.jpg`),
  defaultImg: require(`../assets/img/profile/defaultImg.png`),
  defaultUserImage: require(`../assets/img/profile/default_user_image.png`),
  employeesSampleXL: require(`../assets/files/scheduleSampleUpload.xlsx`),
  loginImage: require(`../assets/img/logo/1723549066041_1723210239994_image_2024_08_02T09_22_50_636Z.png`),
  loginSideImage: require(`../assets/img/logo/1723549077759_1723210309796_image_2024_08_02T09_25_41_371Z.png`),
  // loginLogo: require(`../assets/img/logo/loginLogo.jpg`),
  loaderImage: require(`../assets/loader.gif`),

};
export default configImages;
